const firebaseConfig = {
	apiKey: "AIzaSyDrInAy9Kwid_odqUJ55BZnWChp84qdAxM",
	authDomain: "healthcare-related-websi-4069d.firebaseapp.com",
	projectId: "healthcare-related-websi-4069d",
	storageBucket: "healthcare-related-websi-4069d.appspot.com",
	messagingSenderId: "129680563028",
	appId: "1:129680563028:web:8880a093651fd29220c6c1"
  };

  export default firebaseConfig;